import { useState, useEffect } from "react";
import { deleteApi, getApi, postApi, putApi } from "../../services/api";
import { useForm } from "antd/es/form/Form";
import { toast } from "react-toastify";

export default function useResources() {
	const [searchTerm, setSearchTerm] = useState("");
	const [resources, setResources] = useState([]);
	const [filteredResources, setFilteredResources] = useState([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalType, setModalType] = useState("");
	const [selectedResource, setSelectedResource] = useState(null);
	const [dynamicResources, setDynamicResources] = useState([
		{ id: Date.now() },
	]); // For "Add More Resources"
	const [courses, setCourses] = useState([]);
	const [form] = useForm();

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Fetch courses
				const courses = await getApi("/courses");

				setCourses(courses);
			} catch (error) {
				console.error("Failed to fetch courses:", error);
			}
		};

		fetchData();
	}, []);

	// Fetch resources data from the database
	useEffect(() => {
		const fetchResources = async () => {
			try {
				const response = await getApi(`/resources`);

				if (response && !response.error) {
					setResources(response);
					setFilteredResources(response);
				}
			} catch (error) {
				console.error("Error fetching resources:", error.message);
			}
		};

		fetchResources();
	}, []);

	// Update filtered resources based on the search term
	useEffect(() => {
		if (searchTerm === "") {
			setFilteredResources(resources);
		} else {
			setFilteredResources(
				resources.filter((resource) =>
					resource.name
						.toLowerCase()
						.includes(searchTerm.toLowerCase())
				)
			);
		}
	}, [searchTerm, resources]);

	const determineFileType = (file) => {
		if (file.type.includes("video")) return "video";
		if (file.type.includes("image")) return "image";
		if (file.type.includes("application/pdf")) return "document";
		return "link"; // Default to link if type can't be determined
	};

	const handleFileChange = (file, id) => {
		const type = determineFileType(file);
		const updatedResources = dynamicResources.map((res) =>
			res.id === id ? { ...res, file, type } : res
		);
		setDynamicResources(updatedResources);
	};

	const addDynamicResource = () => {
		setDynamicResources([...dynamicResources, { id: Date.now() }]);
	};

	const removeDynamicResource = (id) => {
		setDynamicResources(dynamicResources.filter((res) => res.id !== id));
	};

	const showModal = (type, resource) => {
		setModalType(type);
		setSelectedResource(resource);
		if (type === "edit") {
			form.setFieldsValue({
				...resource,
			});
		} else {
			form.resetFields();
		}
		setIsModalVisible(true);
	};

	const handleModalConfirm = async (values) => {
		const formData = new FormData();
		Object.entries(values).forEach(([key, value]) => {
			if (key.startsWith("file")) {
				value.forEach((val) =>
					formData.append("files", val?.originFileObj)
				);

				return;
			}
			formData.append(key, value);
		});
		try {
			if (modalType === "edit") {
				await putApi(`/resources/${selectedResource._id}`, {
					name: values.name,
					courseId: values.courseId,
					fileUrl: values.fileUrl,
					type: values.type,
				});
				toast.success("Resource updated successfully");
			} else if (modalType === "delete") {
				await deleteApi(`/resources/${selectedResource._id}`);
				toast.success("Resource deleted successfully");
			} else if (modalType === "add" || !modalType) {
				//adding the not modal type here because the teacher profile resource upload dont have a modal type

				await postApi(`/resources/${values.courses}`, formData);
				toast.success("Resource added successfully");
			}
		} catch (error) {
			console.error("Error updating resource:", error.message);
			toast.error("Error updating resource");
		}

		setIsModalVisible(false);
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};

	return {
		searchTerm,
		setSearchTerm,
		resources,
		setResources,
		filteredResources,
		setFilteredResources,
		isModalVisible,
		setIsModalVisible,
		modalType,
		setModalType,
		selectedResource,
		setSelectedResource,
		dynamicResources,
		setDynamicResources,
		form,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		addDynamicResource,
		removeDynamicResource,
		handleFileChange,
		courses,
	};
}
